import { combineReducers } from '@reduxjs/toolkit';
import mainSlice from '../slices/main/mainSlices';
import userSlice from '../slices/user/userSlices';
import usersSlice from '../slices/users/usersSlices';
import catalogsSlice from '../slices/catalogs/catalogsSlices';
import companySlice from '../slices/company/companySlices';
import productsSlice from '../slices/products/productsSlices';
import productSlice from '../slices/product/productSlices';

const rootReducer = combineReducers({
  main: mainSlice,
  user: userSlice,
  users: usersSlice,
  catalogs: catalogsSlice,
  company: companySlice,
  products: productsSlice,
  product: productSlice,
});

export default rootReducer;
